<script>
import { mapState, mapActions } from 'vuex';
import validatorMixin from '../../mixins/validatorMixin';
import TransportTypes from '../../variables/transportTypes';

export default {
  name: 'FerryRouteEdit',
  props: {
    shown: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    ...mapState({
      route: state => state.transportation.routes.route,
      saveLoading: state => state.transportation.routes.saveLoading,
      saveError: state => state.transportation.routes.saveError,
      nonDynamicTransports: state => state.nonDynamicTransport.overview,
    }),
    changesMade() {
      const changes = true;
      this.$emit('input', changes);
      return changes;
    },
  },
  methods: {
    ...mapActions({
      saveRoute: 'transportation/routesSave',
      getNonDynamicTransports: 'nonDynamicTransport/getNonDynamicTransports',
    }),
    saveEditRoute() {
      if (this.validForm && this.changesMade) {
        this.saveRoute(this.current)
          .then((res) => {
            if (res) {
              this.$emit('close', true);
            }
          });
      }
    },
    formatTransportName(item) {
      return `${item.route[0].departure}->${item.route[0].arrival} (${item.route[0].carrier}) #${item.id}`;
    },
  },
  data() {
    return {
      validForm: true,
      current: undefined,
      transportTypes: TransportTypes,
    };
  },
  created() {
    if (!this.nonDynamicTransports.loading && !this.nonDynamicTransports.items.length) {
      this.getNonDynamicTransports();
    }
  },
  watch: {
    shown() {
      if (this.shown) {
        this.current = Object.assign({}, this.route);
        this.$emit('input', this.changesMade);
      }
    },
  },
  mixins: [validatorMixin],
};
</script>

<template>
  <v-card v-if="route && current">
    <v-form v-model="validForm" @submit.prevent="saveEditRoute">
      <v-card-title class="pb-1">
        <span class="headline">
          {{ $t('transportation.routes.actions.edit.title') }}
        </span>
      </v-card-title>

      <v-card-text class="py-0 mb-3 edit-item-status">
        <v-progress-linear
          class="my-0"
          v-if="saveLoading"
          :active="saveLoading"
          :indeterminate="true"
          :height="4">
        </v-progress-linear>
        <v-alert
          class="my-0 py-2"
          outline
          v-if="!saveLoading"
          :value="!!saveError"
          transition="slide-y-transition">
          {{ $t('errors.saveError') }}
        </v-alert>
      </v-card-text>

      <v-card-text class="py-0">
        <v-container grid-list-md pt-1>
          <v-layout row>
            <v-flex xs2>
              <v-label>
                {{ $t('transportation.routes.table.origin') }}:
              </v-label>
            </v-flex>
            <v-flex xs10 px-4>
              <span class="body-2">{{ route.origin }}</span>
              <span class="font-italic grey--text darken-1 ml-2 caption">
              ({{ route.originExternalRef }})
            </span>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs2>
              <v-label>
                {{ $t('transportation.routes.table.destination') }}:
              </v-label>
            </v-flex>
            <v-flex xs10 px-4>
              <span class="body-2">
                {{ route.destination }}
              </span>
              <span class="font-italic grey--text darken-1 ml-2 caption">
                ({{ route.destinationExternalRef }})
              </span>
            </v-flex>
          </v-layout>

          <v-layout row mt-3>
            <v-flex xs12>
              <v-text-field
                v-model="current.originWebName"
                :rules="[rules.required]"
                :disabled="saveLoading"
                :label="$t('transportation.routes.actions.edit.origin')"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="current.destinationWebName"
                :rules="[rules.required]"
                :disabled="saveLoading"
                :label="$t('transportation.routes.actions.edit.destination')"
              />
            </v-flex>
          </v-layout>

          <v-layout v-if="current.type === transportTypes.FLIGHT" row>
            <v-flex xs12>
              <v-autocomplete
                v-model="current.transportIds"
                :items="nonDynamicTransports.items"
                :loading="nonDynamicTransports.loading"
                :disabled="saveLoading"
                item-value="id"
                :item-text="formatTransportName"
                label="Select non dynamic transport"
                multiple
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-checkbox
                class="mt-0"
                v-model="current.active"
                :disabled="saveLoading"
                :label="$t('transportation.routes.table.active')"
                hide-details
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="red darken-1"
          @click="$emit('close')"
          flat>
          {{ $t('inputs.actions.cancel') }}
        </v-btn>
        <v-tooltip top :disabled="changesMade">
          <template slot="activator" slot-scope="{ on }">
            <div v-on="on">
              <v-btn
                :disabled="!validForm || saveLoading || !changesMade"
                @click="saveEditRoute"
                color="blue darken-1"
                type="submit"
                flat>
                {{ $t('inputs.actions.save') }}
              </v-btn>
            </div>
          </template>
          <span>
            {{ $t('inputs.misc.saveDisabled') }}
          </span>
        </v-tooltip>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<style lang="scss">
  .edit-item-status {
    min-height: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/transportation/TransportationRoutesEdit.vue